import styled from 'styled-components';

export const TableContainer = styled.div`
  overflow-x: auto;
  margin: 1.5rem 0;
  position: relative;
  
  table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid var(--light-gray);
    min-width: 800px; /* Ensures table doesn't get too compressed */
  }
  
  th, td {
    padding: 0.75rem;
    text-align: left;
    border: 1px solid var(--light-gray);
  }
  
  /* Add column width specifications */
  th:nth-child(1),
  td:nth-child(1) {
    width: 17%;
  }
  
  th:nth-child(2),
  td:nth-child(2),
  th:nth-child(3),
  td:nth-child(3),
  th:nth-child(4),
  td:nth-child(4) {
    width: calc(83% / 3);
  }
  
  th {
    background-color: var(--light-blue);
    color: var(--dark-blue);
    font-weight: 600;
    position: sticky;
    top: 0;
    z-index: 10;
  }
  
  tr:nth-child(even) {
    background-color: var(--lightest-gray);
  }
  
  @media (max-width: 768px) {
    border: 1px solid var(--light-gray);
    border-radius: 8px;
    
    th, td {
      padding: 0.6rem;
      font-size: 0.9rem;
    }
  }
`;

export const ScrollIndicator = styled.div`
  display: none;
  
  @media (max-width: 992px) {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    background-color: var(--lightest-blue);
    color: var(--dark-blue);
    border-radius: 4px;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
    
    span {
      margin-right: 0.5rem;
      font-size: 1.2rem;
    }
  }
`;

export const EngageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.2rem;
  margin-top: 1.5rem;

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

export const EngageCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: 2.2rem 1.5rem 2.2rem 1.5rem;
  height: 320px;
  box-shadow: 0 2px 8px rgba(0,0,0,.05);
  transition: transform .2s ease, box-shadow .2s ease;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow-y: auto;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px rgba(0,0,0,.08);
  }

  h3 {
    margin: 0 0 .4rem;
    font-size: 1.15rem;
    color: var(--dark-blue);
    font-weight: 600;
  }

  .subtitle {
    font-size: 0.98rem;
    color: var(--primary-color);
    font-weight: 400;
    margin-bottom: 0.9rem;
    line-height: 1.3;
  }

  p {
    margin: 0;
    font-size: .97rem;
    line-height: 1.5;
    color: var(--text-color);
  }
`; 